<div class="ops-contractor-profile-container">
  <div class="navigation-breadcrumb">
    <a routerLink="/ops-vendor-management" class="breadcrumb-text">
      {{ quarterlyFeedback.Breadcrumb }}
    </a>
    <span class="breadcrumb-separator"> / </span>
    <a (click)="navigateToContractorsList()" class="breadcrumb-text">
      {{ quarterlyFeedback.ContractorList }}
    </a>
    <span class="breadcrumb-separator"> / </span>
    <span class="breadcrumb-text">{{ quarterlyFeedback.Profile }}</span>
  </div>

  <div class="contractor-profile">
    <div class="page-title">{{ ContractorName }}</div>
    <div class="sub-title">{{ ContractorProfile }}</div>

    <div class="row-container">
      <div class="col">
        <emerald-card>
          <div class="header-row">
            <h2 class="heading-title">{{ quarterlyFeedback.About }}</h2>
            <i class="icon info-icon"></i>
          </div>
          <div class="separator"></div>
          <div class="content-container">
            <p *ngFor="let item of aboutItems">
              <strong>{{ item.label }}:</strong>
              <span [title]="item.value">{{ item.value }}</span>
            </p>
          </div>
        </emerald-card>
      </div>

      <div class="col">
        <emerald-card>
          <div class="header-row">
            <h2 class="heading-title">{{ quarterlyFeedback.TeamInfo }}</h2>
            <i class="icon team-icon"></i>
          </div>
          <div class="separator"></div>
          <div class="content-container">
            <p *ngFor="let item of teamInfoItems">
              <strong>{{ item.label }}:</strong>
              <span [title]="item.value">{{ item.value }}</span>
            </p>
          </div>
        </emerald-card>
      </div>

      <div class="col">
        <emerald-card>
          <div class="header-row">
            <h2 class="heading-title">{{ quarterlyFeedback.Performance }}</h2>
            <i class="icon performance-icon"></i>
          </div>
          <div class="separator"></div>
          <div class="content-container">
            <p *ngFor="let item of performanceItems">
              <strong>{{ item.label }}:</strong>
              <span [title]="item.value">{{ item.value }}</span>
            </p>
          </div>
        </emerald-card>
      </div>

      <div class="col">
        <emerald-card>
          <div class="header-row">
            <h2 class="heading-title">{{ quarterlyFeedback.ISkills }}</h2>
            <i class="icon skill-icon"></i>
          </div>
          <div class="separator"></div>
          <div class="content-container">
            <p *ngFor="let skill of skillItems">
              <strong>{{ skill.label }}:</strong>
              <span [title]="skill.value">{{ skill.value }}</span>
            </p>
          </div>
        </emerald-card>
      </div>
    </div>
  </div>

  <div class="quarterly-feedback-section">
    <h2 class="quarterly-feedback-title">{{ quarterlyFeedback.Feedback }}</h2>

    <ng-container *ngFor="let box of quarterBoxes">
      <div class="quarter-card">
        <div class="quarter-header">
          <span class="quarter-label">
            {{ box.label }}
          </span>
        </div>

        <div class="quarter-content">
          <div *ngIf="box.loading" class="loading-small">
            Loading...
          </div>

          <div *ngIf="!box.loading && !box.feedbacks.length && !box.error" class="no-feedback">
            {{ quarterlyFeedback.NoFeedback || 'No feedback' }}
          </div>

          <div *ngIf="!box.loading && box.feedbacks.length">
            <div class="feedback-entry"
                 [class.entry-latest]="idx === 0"
                 [class.entry-previous]="idx > 0"
                 *ngFor="let fb of box.feedbacks; let idx = index; trackBy: trackFeedback"
                 [hidden]="!fb?.performanceRating
                           && (fb?.techincalRating || 0) <= 0
                           && (fb?.behaviouralRating || 0) <= 0">
              <span
                class="entry-badge"
                [class.entry-badge--latest]="idx === 0"
                [class.entry-badge--previous]="idx > 0"
              >
                {{ idx === 0 ? 'Latest' : 'Previous' }}
              </span>
              <div class="entry-header" *ngIf="box.feedbacks.length > 1">&nbsp;</div>

              <!-- AB: new-form rows carry performanceRating (bucket letter);
                   legacy rows carry integer technical + behavioural. Render
                   each shape natively. -->
              <div class="rating-row" *ngIf="fb?.performanceRating">
                <div class="rating-block performance-rating-block">
                  <span class="rating-label">
                    {{ quarterlyFeedback.PerformanceLabel }}:
                    <strong>{{ getPerformanceRatingFullDisplay(fb?.performanceRating) }}</strong>
                  </span>
                </div>
              </div>
              <div class="rating-row"
                   *ngIf="!fb?.performanceRating
                          && ((fb?.techincalRating || 0) > 0 || (fb?.behaviouralRating || 0) > 0)">
                <div class="rating-block">
                  <span class="rating-label">
                    {{ quarterlyFeedback.Technical }} ({{ fb?.techincalRating ?? 0 }}/5)
                  </span>
                  <span class="stars">
                    <ng-container *ngFor="let s of stars; let si = index">
                      <span class="star" [class.filled]="si < (fb?.techincalRating ?? 0)">&#9733;</span>
                    </ng-container>
                  </span>
                </div>

                <div class="rating-block">
                  <span class="rating-label">
                    {{ quarterlyFeedback.Behavioural }} ({{ fb?.behaviouralRating ?? 0 }}/5)
                  </span>
                  <span class="stars">
                    <ng-container *ngFor="let s of stars; let si = index">
                      <span class="star" [class.filled]="si < (fb?.behaviouralRating ?? 0)">&#9733;</span>
                    </ng-container>
                  </span>
                </div>
              </div>

              <div class="feedback-comment-block">
                <div class="feedback-comment-label">Comments:</div>
                <div class="feedback-comment">
                  {{ fb?.comments }}
                </div>
              </div>

              <div class="feedback-meta-row">
                <div>
                  <div *ngIf="fb?.submittedBy">Submitted by: {{ fb.submittedBy }}</div>
                  <div *ngIf="fb?.submittedDate">Submitted on: {{ fb.submittedDate }}</div>
                </div>
              </div>

              <div class="entry-separator" *ngIf="idx < box.feedbacks.length - 1"></div>
            </div>
          </div>

          <div *ngIf="box.error" class="error-text">
            {{ box.error }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
